import { render, staticRenderFns } from "./vip-button-zero-buy.vue?vue&type=template&id=6cfbf783&scoped=true&lang=pug&"
import script from "./vip-button-zero-buy.vue?vue&type=script&lang=js&"
export * from "./vip-button-zero-buy.vue?vue&type=script&lang=js&"
import style0 from "./vip-button-zero-buy.vue?vue&type=style&index=0&id=6cfbf783&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cfbf783",
  null
  
)

export default component.exports